module.exports = __webpack_public_path__ + "static/media/is-this.8a820f34.png";